function createNumber() {
  const numbers = '0123456789';
  let code = '';
  for (let i = 0; i < 5; i++) {
    const indiceAleatorio = Math.floor(Math.random() * numbers.length);
    code += numbers.charAt(indiceAleatorio);
  }
  return code;
}

export default createNumber;
